<template>
  <div class="role">
    <div class="page">
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
            placeholder="ID/商户名称/商户编码"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
          <vs-button type="border" color="primary" @click="addHandle">添加</vs-button>
        </div>
      </div>
      <div class="page-content white-bg">
        <vs-table
          :data="listData"
        >
          <template slot="thead">
            <vs-th class="id-th">
              ID
            </vs-th>
            <vs-th>
              商户名称
            </vs-th>
            <vs-th>
              商户编码
            </vs-th>
            <vs-th>
              商户md5key
            </vs-th>
            <vs-th class="url">
              通知URL
            </vs-th>
            <vs-th>
             创建时间
            </vs-th>
            <vs-th>
              有效期至
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td class="id-th">
                {{tr.id}}
              </vs-td>

              <vs-td>
                {{tr.merName}}
              </vs-td>

              <vs-td>
                <div>{{tr.merCode}}</div>
              </vs-td>
              <vs-td>
                {{tr.merMd5Key}}
              </vs-td>
              <vs-td class="url">
                {{tr.notifyUrl}}
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>
              <vs-td>
                {{tr.validDate}}
              </vs-td>
              <vs-td class="status-th">
                <span
                  class="status"
                  :class="{on: tr.merStatus == 0 }"
                >{{getState(tr)}}</span>
              </vs-td>
              <vs-td>
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="top"
                  >
                    <icon-svg
                      icon-class="edit-21"
                      class="pointer edit-icon"
                      @click.native="editHandle(tr)"
                    ></icon-svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计 {{total}} 条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
    <editOrAdd
      ref="editoradd"
      :active="active"
      @close="closeHandle"
      :is-edit="isEdit"
      :current-id="currentId"
      @done-success="doneSuccess"
      :edit-data="currentUserInfo"
    ></editOrAdd>
  </div>
</template>

<script>
  import editOrAdd from '@/components/merchant/merchantList/editOrAdd'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      editOrAdd,
    },
    data() {
      return {
        addDialogShow: false,
        currentUserInfo: {},
        active: false,
        currentId: 0,
        isEdit: false,
        loading: false,
      }
    },
    mixins: [initData],
    mounted(){
      this.init();
    },
    methods: {
      beforeInit(){
        this.url = 'pms/crm/pageMerchant';
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        return true;
      },
      addHandle() {
        this.isEdit = false;
        this.active = true;
        this.$refs.editoradd.reset();
      },
      getState(tr){
        return tr.merStatus == 1 ? '启用': '禁用';
      },
      editHandle(tr){
        this.isEdit = true;
        this.active = true;
        this.currentUserInfo = tr;
      },
      closeHandle(){
        this.active = false;
      },
      doneSuccess(){
        this.init();
      }
    },
  }
</script>
<style lang="scss">
  .role {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .url {
    span {
      white-space:pre-wrap!important;
    }
  }
  .edit-icon {
    font-size: 20px;
  }
  .status-th {
    min-width: 80px;
  }

</style>
